module.exports = __webpack_public_path__ + "static/media/play_i.9d90289b.svg";